import { HiX } from 'react-icons/hi';
import Button from '@components/ui/Button';
import { useNavigate } from 'react-router';
import { Calculator } from 'lucide-react';

const ConfirmStartQuizModal = ({ isOpen, onClose, quiz, onConfirm=null }) => {
    const navigate = useNavigate();

  if (!isOpen || !quiz) return null;
  
  let startQuiz = ()=> {
    if (onConfirm) {
      onConfirm();
    }

    onClose();
    return navigate(`/quizzes/${quiz.id}/take`);
  }

  return (
    <div className={`modal ${isOpen ? 'modal-open' : ''}`}>
      <div className="modal-box max-w-lg">
        <label className="absolute right-4 top-4">
          <HiX className="h-6 w-6 cursor-pointer" onClick={onClose} />
        </label>

        <h2 className="text-xl font-semibold mb-4">Start {quiz.quiz_type} Quiz?</h2>
        <p className="text-gray-700 mb-6">
          Are you sure you want to start this <strong>{quiz.quiz_type}</strong> quiz now? <br />
          Once started, the timer will begin immediately.
        </p>

        {quiz?.enable_calculator && (
          <div className="flex items-center gap-2 text-xs text-emerald-800 bg-emerald-50 px-3 py-2 rounded-lg border border-emerald-200 mb-4">
            <Calculator className="w-4 h-4 text-emerald-600 flex-shrink-0" />
            <span>On-screen calculator is enabled and will be available during this quiz.</span>
          </div>
        )}

        {quiz.quiz_type === 'exam' && (
          <div className="alert alert-warning mb-4 flex items-center gap-2">
            <span className="text-sm">
              ⚠️ Switching tabs during the exam will automatically submit your quiz.
            </span>
          </div>
        )}

        <div className="modal-action">
          <Button onClick={startQuiz}>Start Quiz</Button>
          <button type="button" className="btn btn-ghost" onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>

      <div className="modal-backdrop" onClick={onClose}>
        <button className="">Close</button>
      </div>
    </div>
  );
};

export default ConfirmStartQuizModal;
